<script lang="ts" setup>
import LogoHeaderIcon from '~/assets/icons/logo-header.svg?url';
import useAccountStore from "~/shared/store/modules/account";
import BalancePopup from "~/entities/navigation/popups/BalancePopup.vue";
import OneSErrorModal from "~/entities/oneSErrors/OneSErrorModal.vue";

const accountStore = useAccountStore();
const route = useRoute()

const availableRoutes = ['account', 'cart', 'order']
const isOneSErrorModal = computed(() => {
  const routeName = route.fullPath.split('/').filter(el => el !== '')[0]
  return availableRoutes.includes(routeName)
})

const navigationLink = [
  {
    name: 'Доставка',
    href: '/delivery',
  },
  {
    name: 'Баланс',
    href: '/account/finance',
    popup: 'balance'
  },
]

</script>

<template>
  <header class="header-order">
    <div class="header-order__wrap container">
      <div class="header-order__logo">
        <NuxtLink
          to="/"
        >
          <img :src="LogoHeaderIcon" alt="logo_order">
        </NuxtLink>
      </div>
      <div class="header-order__navigation">
        <div class="header-order__navigation-item" v-for="link in navigationLink">
          <NuxtLink :to="link.href">
            <span>{{link.name}}</span>
          </NuxtLink>
          <div
            v-if="link.popup === 'balance'"
            class="header-order__popup"
          >
            <div class="header-order__popup-container">
              <BalancePopup v-if="accountStore.balance.length"/>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    TODO: уведомления о технических работах на сайте -->
<!--    <Teleport to="body">-->
<!--      &lt;!&ndash;noindex&ndash;&gt;-->
<!--      <OneSErrorModal-->
<!--        v-if="isOneSErrorModal"-->
<!--      />-->
<!--      &lt;!&ndash;/noindex&ndash;&gt;-->
<!--    </Teleport>-->
  </header>
</template>

<style lang="scss" scoped>
.header-order {

  &__logo {
    img {
      @include xs-breakpoint {
        width: 118px;
        height: 32px;
      }
    }
  }
  &__wrap {
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include xs-breakpoint {
      height: 64px;
      padding: 16px 20px;
    }
  }
  &__navigation {
    display: flex;
    align-items: center;
    gap: 16px;
    &-item {
      position: relative;
      span {
        @include font(14px, 20px, 600);
        color: $content_primary;
        transition: color 0.3s;
        @include xs-breakpoint {
          @include font(16px, 20px, 500);
        }
      }
      &:hover {
        span {
          color: $content_orange;
        }

        .header-order__popup {
          visibility: visible;
          opacity: 1;
          pointer-events: auto;
        }
      }


    }
  }
  &__popup {
    position: absolute;
    right: 0;
    top: 100%;
    padding-top: 8px;
    transition: opacity 0.3s, visibility 0.3s;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    z-index: 10;

    &-container {
      width: 320px;
      padding: 16px 20px;
      border-radius: 12px;
      box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1019607843);
      background-color: $bg_page;
    }
    @include md-breakpoint {
      display: none;
    }
  }
}
</style>
